// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_79fb830","italianLicense":"_4c2e64d","textContainer":"_7f2a4e8","regulatoryButton":"_defe9b9"};